import React, { Fragment } from 'react';
import classNames from 'classnames';
import {
  string, bool,
} from 'prop-types';
import { Small } from 'components/common';

import './CompareElementValue.scss';

const CompareElementValue = ({
  value,
  suffix,
  prefix,
  isMobilePremium,
  verticalEnum,
}) => {
  // TODO find a cleaner and more generic way to allow some vertical to override this condition
  const isLongPrefix = prefix && prefix.length > 2 && verticalEnum !== 'STK';
  return (
    <Fragment>
      {prefix && (
        <Small
          bold
          className={classNames('sup', {
            'hidden-xs-sm': !isMobilePremium && isLongPrefix,
          })}
        >
          {prefix}
        </Small>
      )}
      {value}
      {suffix && (
        <Small
          bold
          className="sub"
        >
          {suffix}
        </Small>
      )}
    </Fragment>
  );
};

CompareElementValue.propTypes = {
  value: string.isRequired,
  suffix: string,
  prefix: string,
  isMobilePremium: bool,
  verticalEnum: string,
};

CompareElementValue.defaultProps = {
  suffix: null,
  prefix: null,
  isMobilePremium: false,
  verticalEnum: null,
};

export default CompareElementValue;
